import React from 'react';
import { AdvertisingPlacementTop2 } from '../components/advertising/AdvertisingPlacement';
import { ToriBottomBannerDisplayProvider } from '../components/advertising/tori/ToriBottomBannerDisplay';
import { FilterList } from '../components/filters/FilterList';
import { FiltersSkipLink } from '../components/filters/FiltersSkipLink';
import { FiltersToolbar } from '../components/filters/FiltersToolbar';
import { SearchToolbar } from '../components/filters/SearchToolbar';
import { useScrollToFilterAction } from '../components/filters/useFilterAction';
import { BreadCrumbs } from '../components/results/BreadCrumbs';
import { ResultList } from '../components/results/ResultList';
import { ResultsSkipLink } from '../components/results/ResultsSkipLink';
import { ResultsToolbar } from '../components/results/ResultsToolbar';
import { useSearchLayoutMessage } from '../components/results/layout/LayoutMessage';
import { usePageReloadOnSearchError } from '../data/SearchData';
import { useSearchFilterMessage } from '../data/SearchQueryMessage';
import { useUrlState } from '../state/UrlState';
import { usePageTracking } from '../tracking/usePageTracking';
import { Root } from './Root';

function DesktopSearchPage() {
    usePageReloadOnSearchError();
    usePageTracking();
    useSearchFilterMessage();
    useSearchLayoutMessage();
    useUrlState();

    const { setScrollToFilterAction, getScrollToFilterActionAndReset } =
        useScrollToFilterAction();

    return (
        <Root>
            <main className="page-container">
                <FiltersSkipLink />
                <ResultsSkipLink />
                <BreadCrumbs />
                <AdvertisingPlacementTop2 />
                <SearchToolbar className="mb-24" />
                <ToriBottomBannerDisplayProvider>
                    <div className="grid grid-cols-3 gap-16 mb-24">
                        <FilterList
                            scrollToFilterAction={
                                getScrollToFilterActionAndReset
                            }
                        />
                        <div className="col-span-2">
                            <FiltersToolbar
                                className="mb-8"
                                onOpen={setScrollToFilterAction}
                            />
                            <ResultsToolbar className="mb-16" />
                            <ResultList />
                        </div>
                    </div>
                </ToriBottomBannerDisplayProvider>
            </main>
        </Root>
    );
}

export const routeObject = {
    Page: DesktopSearchPage,
};

export { DesktopSearchPage as Page };
